export enum MENU_TYPE {
    CATEGORY = "CATEGORY",
    SALE = "SALE",
    LINK = "LINK",
    SUBCATEGORY = "SUBCATEGORY",
    BIG_IMAGE = "BIG_IMAGE",
    TOP_CATEGORIES = "TOP_CATEGORIES",
    SUB_LINK = "SUB_LINK",
    SUB_LINK_HIGHLIGHT = "SUB_LINK_HIGHLIGHT",
    BRANDS = "BRANDS",
    IMAGE = "IMAGE",
    AD_PLATFORM_LINK = "AD_PLATFORM_LINK",
}

export enum MENU_MODES {
    MANUAL = "MANUAL",
    AUTO = "AUTO",
}

export enum MENU_TAGS {
    WHATS_NEW = "WHATS_NEW",
    BRANDS = "BRANDS",
}

export const MENU_NAMES = {
    [MENU_TAGS.WHATS_NEW]: "WHAT'S NEW",
    [MENU_TAGS.BRANDS]: "BRANDS",
};

export enum VIEW_TYPES {
    LIST = "LIST",
    CARD = "CARD",
}

export enum TYPES {
    LINK = "LINK",
    AD_PLATFORM = "AD_PLATFORM",
}

export const DEVICE_TYPE = {
    MOBILE: "mobile",
    DESKTOP: "desktop",
};

export const DEFAULT_INITIALS = [
    "#",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
];

export const PAGE_TYPE = { LISTING: "listing", CURATION: "mm" };
